// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:960px){.symbol.symbol-35[data-v-4957cedc] img{height:28px!important}}.symbol-35[data-v-4957cedc]{-webkit-box-shadow:-3px -3px 10px 5px hsla(0,0%,100%,.3),0 0 5px 2px hsla(0,0%,100%,.5);box-shadow:-3px -3px 10px 5px hsla(0,0%,100%,.3),0 0 5px 2px hsla(0,0%,100%,.5)}", ""]);
// Exports
module.exports = exports;
